import { Transition } from '@headlessui/react';
import { Link } from 'gatsby';
import React from 'react';

const LinkComponentMobile = ({
	obj = null,
	expanded = undefined,
	setExpanded = undefined,
	index = undefined,
	title,
	href,
	setShowMenu = undefined,
	showMenu = undefined,
	disableSingle = false
}) => {
	return (
		<>
			{obj !== null ? (
				<button
					className="relative flex flex-wrap items-center justify-between py-6 space-x-1 text-lg transition-colors hover:text-green"
					onClick={() => {
						if (expanded !== index) {
							setExpanded(index);
						} else setExpanded(0);
					}}
				>
					<Link onClick={() => setShowMenu(!showMenu)} to={`/${href}/`}>
						{title}
					</Link>
					<Arrow index={index} expanded={expanded} />
				</button>
			) : (
				<Link
					className="relative flex flex-wrap items-center justify-between py-6 space-x-1 text-lg transition-colors hover:text-green"
					to={`/${href}/`}
					onClick={() => {
						setShowMenu(!showMenu);
					}}
				>
					<p>{title}</p>
				</Link>
			)}
			{obj !== null && (
				<Transition
					show={expanded === index}
					as="div"
					appear={true}
					enter="transition-all ease-linear origin-top duration-200"
					enterFrom="scale-y-0"
					enterTo="scale-y-100"
					leave="transition-all ease-linear origin-top duration-200"
					leaveFrom="scale-y-100"
					leaveTo="scale-y-0"
					className="overflow-hidden -mx-5 divide-y-[1px]  divide-[#F1F1F5] flex flex-col top-full left-0 bg-[#FBFBFC] text-black"
				>
					{obj.map((sublink, idx) => (
						<Link
							key={idx}
							onClick={() => setShowMenu(!showMenu)}
							className="px-6 py-4 transition-colors whitespace-nowrap hover:text-green"
							to={`/${href}/${sublink.node.Slug}/`}
						>
							{sublink.node.Name}
						</Link>
					))}
					{!disableSingle && (
						<Link
							onClick={() => setShowMenu(!showMenu)}
							className="px-6 py-4 transition-colors whitespace-nowrap text-green hover:text-black"
							to={`/${href}/`}
						>
							See all
						</Link>
					)}
				</Transition>
			)}
		</>
	);
};

const Arrow = ({ expanded, index }) => {
	return (
		<svg
			className={`${expanded === index ? 'rotate-180' : 'rotate-0'} transition-transform`}
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			fill="none"
			viewBox="0 0 12 12"
		>
			<path
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.75 4.5L6 8.25 2.25 4.5"
			/>
		</svg>
	);
};

export default LinkComponentMobile;
